/* @flow */
import { ReduceStore } from 'flux/utils';

import { ActionTypes } from 'constants/AvatarConstants';
import { dispatcher } from 'lib/Dispatcher';
import GroupAvatars from 'collections/GroupAvatars';

class AvatarStore extends ReduceStore {

  getInitialState() {
    return {
      groupAvatars: {
        loaded: false,
        collection: new GroupAvatars(),
      },
    };
  }

  getGroupAvatars() {
    return this.getState().groupAvatars.collection;
  }

  areGroupAvatarsLoaded() {
    return this.getState().groupAvatars.loaded;
  }

  reduce(state, action) {
    switch (action.type) {
      case ActionTypes.GROUP_AVATARS_LOADED:
        return {
          groupAvatars: {
            loaded: true,
            collection: action.avatars,
          },
        };
      default:
        return state;
    }
  }
}

export default new AvatarStore(dispatcher);



// WEBPACK FOOTER //
// ./src/stores/AvatarStore.js